import apiService from './api.service';

class SectionsService {
  async getSectionByUid(uid) {
    try {
      const response = await apiService.post('/sections/get-by-uid', {UID: uid}, {}, true);
      if (response && response.code === 1 && response.data) {
        const sectionData = Array.isArray(response.data) ? response.data[0] : response.data;
        
        // Filter out unpublished content
        if (sectionData && sectionData.IsPublished === false) {
          return {
            success: false,
            data: null,
            message: 'Section is not published',
          };
        }
        
        return {
          success: true,
          data: sectionData,
          message: response.message,
        };
      }
      
      return {
        success: false,
        data: null,
        message: response?.message || 'Failed to fetch section content',
      };
    } catch (error) {
      return {
        success: false,
        data: null,
        message: error.message || 'An error occurred while fetching section content',
      };
    }
  }

  async getWhoAreWeSection() {
    return this.getSectionByUid('HOME-RIGHTSIDE-CGI-SECTION');
  }

  async getJobVacancySection() {
    return this.getSectionByUid('HOME-VACANCY');
  }

  transformSectionData(apiData) {
    const transformed = { 
      title: apiData.Title || apiData.title,
      subtitle: apiData.SubTitle || apiData.subtitle,
      content: apiData.Description || apiData.description || apiData.Content,
      shortDescription: apiData.SubTitle || apiData.shortDescription,
      link: apiData.Link || apiData.link,
      imageUrl: apiData.ImageUrl || apiData.imageUrl,
    };
    
    return transformed;
  }
}

export default new SectionsService();
